import ApiClient from '@/services/apiClient';

export default class Range {
    enable;
    start;
    end;

    constructor(enable = false, start = 0, end = 0) {
        this.enable = enable;
        this.start = start;
        this.end = end;
    }

    /**
     * Constructs a <code>Range</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Range} obj Optional instance to populate.
     * @return {module:model/Range} The populated <code>Range</code> instance.
     */
    static constructFromObject(data, obj) {
        obj = obj || new Range();
        if (data) {
            obj.enable = true;
            if (Object.prototype.hasOwnProperty.call(data, 'enable'))
                obj.enable = ApiClient.convertToType(data['enable'], 'Boolean');
            if (Object.prototype.hasOwnProperty.call(data, 'start'))
                obj.start = ApiClient.convertToType(data['start'], 'Integer');
            if (Object.prototype.hasOwnProperty.call(data, 'end'))
                obj.end = ApiClient.convertToType(data['end'], 'Integer');
        }
        return obj;
    }

    toJSON() {
        const json = {
            start: this.start,
            end: this.end,
        };
        return json;
    }
}
